import React, { useEffect, useState } from "react";
import { postGasto as addGasto } from "../helpers/rutaGastos";
import { getCuentasGasto } from "../helpers/rutaCuentaGasto";

import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const AddGastoForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [cuentas, setCuentas] = useState({ data: [], loading: true });

  const [formValues, setFormValues] = useState({
    codgas: "",
    gasto: "",
    cuenta: "", // ✅ ObjectId de CuentaGasto
  });

  useEffect(() => {
    getCuentasGasto().then((resp) => {
      const lista = Array.isArray(resp) ? resp : resp?.cuentasgasto || [];
      setCuentas({ data: lista.filter((x) => x.activo), loading: false });
    });
  }, []);

  const handleChange = (e) => {
    setFormValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const resetForm = () =>
    setFormValues({
      codgas: "",
      gasto: "",
      cuenta: "",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      gasto: String(formValues.gasto || "").trim(),
      cuenta: formValues.cuenta, // ✅ ObjectId
    };

    try {
      console.log("🚀 Payload POST /gastos:", payload);
      const resp = await addGasto(payload);
      console.log("✅ Gasto creado:", resp);

      // si tu helper devuelve {ok:false}
      if (resp?.ok === false) {
        console.error("❌ Error:", resp?.error);
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        resetForm();
        // si querés cerrar el modal principal:
        // setShow(false);
      }, 1200);
    } catch (error) {
      console.error("❌ Error al crear gasto:", error);
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            {/* ✅ CuentaGasto */}
            <div className="form-group mt-3 col-sm-5">
              <label>Cuenta</label>
              <select
                className="form-control"
                name="cuenta"
                required
                value={formValues.cuenta}
                onChange={handleChange}
                disabled={cuentas.loading}
              >
                <option value="">
                  {cuentas.loading ? "Cargando cuentas..." : "Seleccione una cuenta"}
                </option>
                {cuentas.data.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.cuenta}
                  </option>
                ))}
              </select>
            </div>

            {/* ✅ Gasto */}
            <div className="form-group mt-3 col-sm-5">
              <label>Gasto</label>
              <input
                type="text"
                className="form-control"
                name="gasto"
                maxLength="50"
                required
                value={formValues.gasto}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddGastoForm;